export const COLORS = [
  '#5891F7',
  '#F5BD43',
  '#6DCDFA',
  '#F2A6E6',
  '#29B526',
  '#7856FF',
  '#DA3831',
  '#171B79',
]
